import { render, staticRenderFns } from "./PrepTaskServerTable.vue?vue&type=template&id=3129b022"
import script from "./PrepTaskServerTable.vue?vue&type=script&lang=js"
export * from "./PrepTaskServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports